import { Injectable } from "@angular/core";
import { UserSessionType } from "../../types/core/models/user-session.type";
import { JwtHelperService } from "@auth0/angular-jwt";

@Injectable()
export class CoreMapper {
    constructor(private jwtHelper: JwtHelperService) {}

    mapUserSession(data: any, currentUser?: UserSessionType): UserSessionType {
        //const decodedToken = this.jwtHelper.decodeToken(data.access_token);
        const result =
            currentUser !== undefined ? currentUser : new UserSessionType();

        // result.userName = decodedToken.unique_name;
        //  result.fullName = decodedToken.PersonName;
        result.token = data.access_token;
        result.tokenType = data.token_type;
        result.refreshToken = data.refresh_token;
        // result.isOwner = decodedToken.owner ? true : false;
        // result.tenantId = decodedToken.tenantId;

        return result;
    }
}
